import React from 'react';
import { Box, Typography } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { getGradeLabel } from '@Utils/gradeLabels';
import { Coverage, selectQualifier } from './explanation.utils';

export interface CoverageQualifierProps {
	grade: number;
	coverage?: Coverage;
}

// Legacy grade keys by numeric grade, for getGradeLabel.
const GRADE_KEYS = ['negligible', 'low', 'medium', 'high', 'extreme'];
const AMBER = '#9a5b25';

// The Minimal-coverage qualifier (spec D2), shown above everything else in
// the Explanation panel.
export const CoverageQualifier = ({
	grade,
	coverage,
}: CoverageQualifierProps) => {
	const { t } = useGlobalization();
	const qualifier = coverage ? selectQualifier(coverage.pct, grade) : null;

	if (qualifier === 'dontAct' && coverage)
		return (
			<Box
				role="status"
				data-cy="explanation-qualifier"
				sx={{
					mb: 2,
					p: 1.5,
					borderRadius: 1,
					border: `1px solid ${AMBER}`,
					background: '#fdf3e7',
					color: '#7a4a1f',
				}}>
				<Typography variant="body2" sx={{ fontWeight: 600 }}>
					{t(
						// eslint-disable-next-line quotes -- apostrophe; prettier requires double quotes here
						"{{grade}} — but only {{real}} of {{total}} inputs are this asset's own data. Don't act on this yet; inspect first.",
						{
							grade: getGradeLabel(GRADE_KEYS[grade] ?? '', t),
							real: coverage.real,
							total: coverage.total,
						},
					)}
				</Typography>
			</Box>
		);
	if (qualifier === 'mayUnderstate')
		return (
			<Typography
				role="status"
				data-cy="explanation-qualifier"
				variant="body2"
				sx={{ mb: 2, color: 'text.secondary' }}>
				{t(
					'Most inputs are defaults — this grade may understate the risk.',
				)}
			</Typography>
		);
	return null;
};

export default CoverageQualifier;
